/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExecuteReportResponse } from './ExecuteReportResponse';
import {
    ExecuteReportResponseFromJSON,
    ExecuteReportResponseFromJSONTyped,
    ExecuteReportResponseToJSON,
    ExecuteReportResponseToJSONTyped,
} from './ExecuteReportResponse';

/**
 * 
 * @export
 * @interface ResultOfExecuteReportResponse
 */
export interface ResultOfExecuteReportResponse {
    /**
     * 
     * @type {ExecuteReportResponse}
     * @memberof ResultOfExecuteReportResponse
     */
    data: ExecuteReportResponse | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResultOfExecuteReportResponse
     */
    isSuccess: boolean;
    /**
     * 
     * @type {Error}
     * @memberof ResultOfExecuteReportResponse
     */
    error: Error | null;
}

/**
 * Check if a given object implements the ResultOfExecuteReportResponse interface.
 */
export function instanceOfResultOfExecuteReportResponse(value: object): value is ResultOfExecuteReportResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ResultOfExecuteReportResponseFromJSON(json: any): ResultOfExecuteReportResponse {
    return ResultOfExecuteReportResponseFromJSONTyped(json, false);
}

export function ResultOfExecuteReportResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfExecuteReportResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ExecuteReportResponseFromJSON(json['data']),
        'isSuccess': json['isSuccess'],
        'error': json['error'],
    };
}

export function ResultOfExecuteReportResponseToJSON(json: any): ResultOfExecuteReportResponse {
    return ResultOfExecuteReportResponseToJSONTyped(json, false);
}

export function ResultOfExecuteReportResponseToJSONTyped(value?: ResultOfExecuteReportResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ExecuteReportResponseToJSON(value['data']),
        'isSuccess': value['isSuccess'],
        'error': value['error'],
    };
}

